<ul *ngFor="let model of models" role="menu" class="menu-list" [formGroup]="formGroup">
  <ng-container *ngFor="let menuItem of menuItems">
    <li class="menu-list__item menu-list__item--radio radio-control">
      <input
        class="radio-control__input"
        id="{{ 'input_themes_' + menuItem.value }}"
        type="radio"
        [value]="menuItem.value"
        [formControlName]="model"
        (click)="menuItemClicked.emit({ $event, menuItem })"
      >
      <label class="radio-control__label" for="{{ 'input_themes_' + menuItem.value }}">{{ menuItem.label }}</label>
    </li>
  </ng-container>
</ul>

<footer *ngIf="footerTemplate" class="menu-footer">
  <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
</footer>
